const details = {
  linkedIn: {
    loveBabbar: "https://in.linkedin.com/in/love-babbar-38ab2887",
    striver:
      "https://pl.linkedin.com/in/rajarvp?trk=people-guest_people_search-card",
    apnaCollege: "https://in.linkedin.com/in/shradha-khapra",
  },
  youTube: {
    loveBabbar: "https://www.youtube.com/c/CodeHelpbyBabbar",
    striver: "https://www.youtube.com/@takeUforward",
    apnaCollege: "https://www.youtube.com/@ApnaCollegeOfficial",
  },
};

export default details;
